import SummaryReport from "@/pages/r4SettlementReport/summaryReport/summaryReport";
import BillConfirm from "@/pages/r4SettlementReport/billConfirm/billConfirm";
import ActivityBillList from "@/pages/r4SettlementReport/activity";
import layout from "@/components/layout/layout";
// r4切结算中心的供应商
const r4SettlementReportRouter = {
  path: "/report",
  component: layout,
  meta: { roles: ["r4gys"], title: "对账管理", icon: "icon-guanlibaobiaoon" },
  children: [
    {
      path: "/r4/report/activityBillList",
      component: ActivityBillList,
      name: "activity",
      meta: {
        roles: ["factory", "pingtai", "zhifa", "jgj", "r4gys", "shop"],
        title: "活动账单确认"
      }
    },
    {
      path: "/r4/report/billConfirm",
      component: BillConfirm,
      name: "r4billConfirm",
      meta: { roles: ["r4gys"], title: "账单确认" }
    },
    {
      path: "/r4/report/summaryReport",
      component: SummaryReport,
      name: "r4summaryReport",
      meta: { roles: ["r4gys"], title: "对账汇总" }
    }
  ]
};
export default r4SettlementReportRouter;



// WEBPACK FOOTER //
// ./src/router/modules/r4SettlementReportRouter.js